import es from "./es.ts";
import en from "./en.ts";
import pt from "./pt.ts";

class Translate {
  _lang: string = (window as any).lang || "es";
  _translationFiles: any = {
    es,
    en,
    pt
  };

  constructor() { }

  set lang(lang: string) {
    this._lang = lang;
  }

  get lang() {
    return this._lang;
  }

  get currTranslations() {
    return this._translationFiles[this._lang];
  }

  translate(key: string): string {
    if (!this._lang) return "";
    return this.currTranslations[key] || `**${key}**`;
  }
}

const translation = new Translate();
export const t = (key: string) => translation.translate(key);
export const setLang = (lang: string) => (translation.lang = lang);
export const getLang = () => translation.lang;
export const getLangString = () => {
  switch (translation.lang) {
    case "es":
      return "Español";
    case "en":
      return "English";
    case "pt":
      return "Português";
    default:
      return "Unknown";
  }
};
